export const createFilteringParams = (filters = {}) => (
    {
        filtering: {
            ...filters
        }
    }
);
